export default class TokenService {
    constructor() {
        this.TOKEN_KEY = 'token';
    }


    getToken() {
        return localStorage.getItem(this.TOKEN_KEY);
    }


    saveToken(accessToken) {
        localStorage.setItem(this.TOKEN_KEY, accessToken);
    }


    removeToken() {
        return localStorage.removeItem(this.TOKEN_KEY);
    }
}